import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Hook to invalidate the connected MCP apps query.
 * Use this after disconnecting an app.
 */
export const useInvalidateMcpConnections = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["useMcpConnectionsQuery"]
    });
  }, [queryClient]);
};
